import { useRef, useState } from 'react'

import { currentPageParams } from 'scrivito'

import { writeUrlParams } from '@/hooks/useUrlParams'
import { ensureString } from '@/utils/ensureString'

export const useEntitySearch = () => {
  const searchRef = useRef<HTMLInputElement>(null)
  const [searchValue, setSearchValue] = useState(() =>
    ensureString(currentPageParams()['search'] ?? null),
  )

  const onSearchClick = () => writeUrlParams({ search: searchValue })

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearchClick()
    }
  }

  const onChange = () => {
    setSearchValue(searchRef.current?.value ?? '')
  }

  return { searchRef, searchValue, onSearchClick, onKeyDown, onChange }
}
